import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiTableHead: MuiComponent<"MuiTableHead"> = {
  styleOverrides: {
    root: {
      backgroundColor: Colors.TableHeaderBackground,
      borderRadius: 8,
    },
  },
};

export const MuiTableRow: MuiComponent<"MuiTableRow"> = {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${Colors.TableBorder}`,
    },

    head: {
      borderBottom: `1px solid ${Colors.TableHeaderBorder}`,
    },
  },
};

export const MuiTableCell: MuiComponent<"MuiTableCell"> = {
  styleOverrides: {
    root: {
      borderBottom: 'transparent',
      color: Colors.White,
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 300,
    },
    head: {
      color: Colors.TableHeaderText,
      borderBottom: 'none',
      fontSize: '12px',
      lineHeight: '20px',
      fontWeight: 500,
      padding: '10px 16px',
    },
  },
};
